/**
 * Login-Flow-Helpers (Phase 3.5 §2 Minimal-Stub, voll in §3).
 *
 * Aktuell: nur `redirectToLogin()` — wird vom API-Client bei 401 aufgerufen.
 * In §3 kommen: Login-Page-Render + Callback-Hash-Parser + Token-Store-Wire.
 */

import { WORKER_URL } from "../api/client";

/**
 * Navigiert zum Worker-OAuth-Login-Endpoint. Worker macht 302 zu Google,
 * Google redirected zum Worker-Callback, Worker setzt Token in URL-Hash
 * und 302 zurück zu `${frontend_origin}/login/callback`.
 *
 * Frontend MUSS `${origin}/login/callback` als Route registrieren (§3+§4).
 */
export function redirectToLogin(redirectTo?: string): void {
  const target = redirectTo ?? window.location.pathname + window.location.search;
  // Basis nötig, weil WORKER_URL seit E11b im Normalfall leer ist (Proxy).
  const loginUrl = new URL(`${WORKER_URL}/api/v1/auth/google/login`, window.location.origin);
  loginUrl.searchParams.set(
    "redirect_to",
    window.location.origin + (target.startsWith("/") ? target : `/${target}`)
  );
  window.location.href = loginUrl.toString();
}
